import React from "react";
import PropTypes from "prop-types";
import { Modal } from "semantic-ui-react";
import Post from "../Post";
import "./index.css";
import { constructPostSlugPath } from "../../util";
import { pushState, back } from "../../util/windowHistory";

// TODO: refactore this to remove HACK's
export const PostModal = ({ post, isOpen, actions }) => {
  return (
    <div className="post-modal-wrapper">
      <Modal
        basic
        open={isOpen}
        onMount={() => {
          const postPath = constructPostSlugPath(post);
          pushState("Post", postPath);
        }}
        onClose={() => {
          back();
          actions.hideModal();
        }}
        closeIcon={"close"}
        className="casemodal"
      >
        <Post post={post} closeModal={actions.hideModal} container="modal" />
      </Modal>
    </div>
  );
};

PostModal.propTypes = {
  actions: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default PostModal;



// WEBPACK FOOTER //
// ./src/components/PostModal/index.js